module.exports = __webpack_public_path__ + "static/media/visa_logo.fdabc70a.png";